module.exports = __webpack_public_path__ + "static/media/DQ-Assessment.0899ee76.png";